import React from "react";

import { Typography } from "@mui/material";

import { PageStandard } from "components/admin/PageStandard";
import { ButtonLink } from "components/MUIExtensions/ButtonLink";
import { BlockStandard } from "components/admin/BlockStandard";

const PAGE_DATA = {
  title: "Alteração em andamento",
  subtitle: "O link para mudança de senha foi enviado para o seu e-mail, por segurança.",
  buttonText: "Concluído",
  to: "/admin",
};

export const PasswordReset = () => {
  const { title, subtitle, buttonText, to } = PAGE_DATA;
  return (
    <PageStandard title={title}>
        <BlockStandard hideDivider>
            <Typography align="center" variant="h2" fontWeight="normal" sx={{ mt: 5, mb: 5}}>{subtitle}</Typography>
            <ButtonLink variant="contained" to={to}>{buttonText}</ButtonLink>
            </BlockStandard>
    </PageStandard>

  );
};